<template>
  <div
    class="pl-1 pr-3 pb-3 flex flex-col gap-2"
    :class="type === 'checkbox' ? 'text-center' : ''"
  >
    <p
      v-if="type !== 'input'"
      class="text-sm text-grey font-semibold h-5"
      :class="type == 'icon' || type == 'boolean' ? 'text-center' : ''"
    >
      {{ name }}
    </p>
    <input
      v-if="!type"
      class="bg-transparent w-full border border-grey-light rounded-md px-1 h-7"
      :modelValue="modelValue"
      @input="handleUpdateInput"
    />
    <input
      v-else-if="type === 'input'"
      :placeholder="name"
      class="bg-transparent w-60 border border-grey-light rounded-md px-1 h-9"
      :modelValue="modelValue"
      @input="handleUpdateInput"
    />
    <div
      v-else-if="type == 'select'"
      class="w-full border border-grey-light rounded-md px-1 h-7 flex flex-row justify-between items-center cursor-pointer relative"
      @click="toggleSelect"
      ref="tableSelectTrigger"
    >
      <p class="w-full select-none truncate"></p>
      <arrow-icon class="flex-shrink-0 mr-1 ml-2" :fillClass="'fill-grey'" />
      <div
        class="absolute top-8 left-0 w-full bg-white scrollbar rounded-md flex flex-col gap-1 transition-all"
        :class="
          selectActive
            ? 'border border-grey-light max-h-64 overflow-auto'
            : 'border-0 border-transparent max-h-0 overflow-hidden'
        "
      >
        <div
          v-for="(option, index) in options"
          :key="index"
          class="w-full transition-all bg-primary bg-opacity-0 hover:bg-opacity-10 h-10 flex flex-row justify-between items-center px-1"
        >
          <p class="w-full px-1 truncate select-none">
            {{ option }}
          </p>

          <checked-icon
            class="transition-opacity flex-shrink-0 mx-2"
            :fillClass="'fill-primary'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import ArrowIcon from "../icons/ArrowIcon.vue";
import CheckedIcon from "../icons/CheckedIcon.vue";

export default defineComponent({
  name: "TableHeader",
  components: { ArrowIcon, CheckedIcon },
  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
    modelValue: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup(_, context) {
    const selectActive = ref(false);

    function handleUpdateInput(event) {
      const targetValue = event.target.value;
      updateValueChange(targetValue);
    }

    function updateValueChange(value) {
      context.emit("update:modelValue", value);
    }

    function toggleSelect() {
      selectActive.value = !selectActive.value;
    }

    return { selectActive, handleUpdateInput, updateValueChange, toggleSelect };
  },
});
</script>
